import { danger } from '../../../../../utils/brandColors';

export default () => ({
  editButton: { marginLeft: '4px' },
  rolesTypography: { cursor: 'pointer' },
  error: { color: danger[500] },
  listRoot: { minWidth: 250 },
  footer: {
    textAlign: 'right',
    padding: '1rem',
  },
  userChip: {
    marginBottom: '1rem',
    fontSize: '.75rem',
    fontWeight: 500,
  },
  chipIcon: { fontSize: '1.5em' },
  right: { textAlign: 'right' },
  passiveActiveSwitch: { width: '100%' },
});
